import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ajax from '@/utils/http'
import store from '@/store/index'
import 'lib-flexible'
import "@/scss/input.scss"
import utils from '@/utils/utils'

import {Button} from 'vant';
import {Tabbar, TabbarItem} from 'vant';
import {Swipe, SwipeItem} from 'vant';
import {Cell, CellGroup} from 'vant';
import {NoticeBar} from 'vant';
import {Tab, Tabs} from 'vant';
import {Field} from 'vant';
import {Toast} from 'vant';
import {Dialog} from 'vant';
import {List} from 'vant';
import {Uploader} from 'vant';
import {ActionSheet} from 'vant';
import {Switch} from 'vant';
import {Rate} from 'vant';
import {Popup} from 'vant';

Vue.use(Popup);
Vue.use(Rate);
Vue.use(Switch);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Tabbar).use(TabbarItem);
Vue.use(Cell).use(CellGroup);
Vue.use(Tab).use(Tabs);
Vue.use(Button);
Vue.use(Field);
Vue.use(NoticeBar);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(List);
Vue.use(Uploader);
Vue.use(ActionSheet);

Vue.config.productionTip = false;

Vue.prototype.utils = utils;
Vue.prototype.baseUrl = ajax.instance.defaults.baseURL;
// 图片地址前缀
Vue.prototype.imgBaseUrl = "https://api.xmi.cash/";

Vue.prototype.ajax = ajax;
Vue.prototype.$toast = Toast;

let protocolStr = document.location.protocol;
if (protocolStr === "http:") {
    console.log("protocol = " + protocolStr);
    // window.location.href = "https://xmi.cash";
}

// 隐藏号码中四位
Vue.prototype.hideAccount = (account) => {
    if (account) {
        return account.substr(0, 3) + '****' + account.substr(7, account.split('').length);
    }
};

/* 时间格式化 */
Vue.prototype.formatDate = (time, type = 1) => {
    let date = new Date(time * 1000);
    let object = {
        "y+": date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate() < 10 ? `0${date.getDate()}` : date.getDate(),
        'H+': date.getHours() < 10 ? `0${date.getHours()}` : date.getHours(),
        'm+': date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes(),
        's+': date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds(),
    };
    switch (type) {
        case 1:
            return `${object["y+"]}-${object["M+"]}-${object["d+"]}`;
        case 2:
            return `${object["y+"]}-${object["M+"]}-${object["d+"]} ${object["H+"]}:${object["m+"]}:${object["s+"]}`;
    }
};

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
